export { default as VisuallyHidden } from './component';